import React, { useState } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styles from './index.module.css';
import TrackingReport from './Tracking';

const Reports: React.FC = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState<number>(0);

  return (
    <div className={styles.wrapper}>
      <Tabs
        className={styles.tabs}
        value={tab}
        onChange={(_e, value) => setTab(value)}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label={t('root:tracking')} />
      </Tabs>
      <div className={styles.tabContent}>
        {tab === 0 && <TrackingReport />}
      </div>
    </div>
  );
};

export default Reports;
